import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import * as moment from 'moment-timezone';
import { DeactivationReason } from './deactivation-reason';

@inheritSerialization(AbstractModel)
export class DriverSuspensionDetail extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserializeAs(DeactivationReason)
  deactivationReason: DeactivationReason;

  @autoserializeAs(Date)
  effectiveAt: Date;

  @autoserialize
  durationHours: number;

  @autoserialize
  cancelReservations: boolean;

  @autoserialize
  active: boolean;

  @autoserialize
  effective: boolean;

  @autoserialize
  createdBy: string;

  @autoserialize
  cancelledBy: string;
}
